import type { BreedSchema } from '../types/breed';

export const CatBreedList: BreedSchema[] = [
  { id: '7', type: 'cat', breedName: 'Moggie', isMixed: true },
  { id: '8', type: 'cat', breedName: 'Non Pedigree Longhair', isMixed: true },
  { id: '9', type: 'cat', breedName: 'Non Pedigree Shorthair', isMixed: true },
  { id: '10', type: 'cat', breedName: 'Domestic Longhair', isMixed: true },
  { id: '11', type: 'cat', breedName: 'Domestic Semi Long Hair', isMixed: true },
  { id: '12', type: 'cat', breedName: 'Domestic Shorthair', isMixed: true },
  { id: '13', type: 'cat', breedName: 'Foreign Shorthairs', isMixed: true },
  { id: '14', type: 'cat', breedName: 'Longhairs', isMixed: true },
  { id: '15', type: 'cat', breedName: 'Mixed Breed Cat', isMixed: true },
  { id: '17', type: 'cat', breedName: 'Abyssinian' },
  { id: '19', type: 'cat', breedName: 'American Blue' },
  { id: '20', type: 'cat', breedName: 'American Curl' },
  { id: '21', type: 'cat', breedName: 'American Shorthair' },
  { id: '22', type: 'cat', breedName: 'American Wirehair' },
  { id: '23', type: 'cat', breedName: 'Angora' },
  { id: '24', type: 'cat', breedName: 'Asian Leopard' },
  { id: '25', type: 'cat', breedName: 'Balinese' },
  { id: '26', type: 'cat', breedName: 'Bengal' },
  { id: '27', type: 'cat', breedName: 'Birman' },
  { id: '29', type: 'cat', breedName: 'Blue Tabby' },
  { id: '30', type: 'cat', breedName: 'Bobtail' },
  { id: '31', type: 'cat', breedName: 'British Shorthair' },
  { id: '32', type: 'cat', breedName: 'Burmese' },
  { id: '33', type: 'cat', breedName: 'Burmilla' },
  { id: '34', type: 'cat', breedName: 'California Rex' },
  { id: '35', type: 'cat', breedName: 'Cornish Rex' },
  { id: '36', type: 'cat', breedName: 'Cymric' },
  { id: '37', type: 'cat', breedName: 'Devon Rex' },
  { id: '38', type: 'cat', breedName: 'Egyptian Mau' },
  { id: '39', type: 'cat', breedName: 'Exotic Shorthair' },
  { id: '40', type: 'cat', breedName: 'Forest Cat' },
  { id: '41', type: 'cat', breedName: 'Havana' },
  { id: '42', type: 'cat', breedName: 'Japanese Bobtail' },
  { id: '43', type: 'cat', breedName: 'Korat' },
  { id: '44', type: 'cat', breedName: 'Maine Coon' },
  { id: '45', type: 'cat', breedName: 'Manx' },
  { id: '46', type: 'cat', breedName: 'Oriental' },
  { id: '47', type: 'cat', breedName: 'Persian' },
  { id: '48', type: 'cat', breedName: 'Ragdoll' },
  { id: '49', type: 'cat', breedName: 'Rex' },
  { id: '51', type: 'cat', breedName: 'Scottish Folds' },
  { id: '52', type: 'cat', breedName: 'Siamese' },
  { id: '53', type: 'cat', breedName: 'Snow Leopard Bengal Cat' },
  { id: '54', type: 'cat', breedName: 'Somali' },
  { id: '55', type: 'cat', breedName: 'Sphynx' },
  { id: '56', type: 'cat', breedName: 'Tiffanie' },
  { id: '57', type: 'cat', breedName: 'Tiffany' },
  { id: '58', type: 'cat', breedName: 'Tonkinese' },
  { id: '59', type: 'cat', breedName: 'Turkish Van Cat' },
  { id: '344', type: 'cat', breedName: 'Bombay' },
  { id: '345', type: 'cat', breedName: 'Munchkin' },
  { id: '346', type: 'cat', breedName: 'Nebelung' },
  { id: '347', type: 'cat', breedName: 'Ocicat' },
  { id: '348', type: 'cat', breedName: 'Russian Blue' },
  { id: '349', type: 'cat', breedName: 'Singapura' },
  { id: '350', type: 'cat', breedName: 'Snowshoe' },
  { id: '16', type: 'cat', breedName: 'White Cats (All breeds)' }, // isMixed ?
];
